﻿import { EventAsyncGS, EventAsyncGSToken } from '@ivanlog/gs';
import { ethers } from "ethers";
import { App } from '../App';
import { LPXContract, LPXReserves } from './LPXContract';
import { WrappedETHContract } from './WrappedETH';
import { ERC20Helper } from './ERC20Helper';
import { BiMath } from '../libs/BiMath';
import { LPXCtrlPoolsContract } from './LPXCtrlPoolsContract';
import { LPXLibProfitContract } from './LPXLibProfitContract';
import { ChainProvider } from './abstact/ContractFacade';
import { error } from 'console';


type ConfigPack = {
    feeIndex: bigint;
    ntzIndex: bigint;
    profitIndex: bigint;
    managerRewardIndex: bigint;
    poolType: number;
    hasPoolFlag_ManagerOnly:boolean;
};

export class LPXInfrastructure
{
    public static ADDRESS_LPX:string = "0x43993C4faA1bE0915A03a3DCF88223D4c1897Cb1";
    public static ADDRESS_LPXCtrlPools:string = "0x30328F88930C1E99D815F8d4588d9c15840D41F8";
    public static ADDRESS_LPXLibArbProfit:string = "0x6e718Cfde0659B8331f17A43D4773b3094671655";
    public static ADDRESS_WPLS:string = "0xA1077a294dDE1B09bB078844df40758a5D0f9a27";
    public static ADDRESS_ERC20Helper:string="0x9fa22DC4b8879642fbE82F2CA433724d6975B8f4";
    public static ADDRESS_DEBUG:string = "0x07B2F1Ed9B644dB28Ad7051bEF2bA51d443a8b4C";


    public static PACKFLAG_MANAGER_ONLY:number=128;

    private _lpx:LPXContract;
    private _lpxCtrlPools:LPXCtrlPoolsContract;
    private _lpxLibArbProfit:LPXLibProfitContract;
    
    private _wpls:WrappedETHContract;
    private _erc20Helper:ERC20Helper;


    private _symbols:Map<string, string> = new Map<string, string>();
    private _decimals:Map<string, bigint> = new Map<string, bigint>();
    private _apr:Map<number, number> = new Map<number, number>();

    private _onRefresh:EventAsyncGS;
    private _onRefreshToken:EventAsyncGSToken<void>;

    constructor(){
        this._onRefreshToken = new EventAsyncGSToken<void>();
        this._onRefresh = new EventAsyncGS(this._onRefreshToken);
        console.log(LPXInfrastructure.ADDRESS_LPX)

        this._symbols.set("0x57fde0a71132198BBeC939B98976993d8D89D225","eHEX");
        this._decimals.set("0x2b591e99afE9f32eAA6214f7B7629768c40Eeb39",BigInt(100000000))
        this._decimals.set("0x57fde0a71132198BBeC939B98976993d8D89D225",BigInt(100000000))
        this._decimals.set("0x3819f64f282bf135d62168C1e513280dAF905e06",BigInt(1000000000))
        this._decimals.set("0xfc4913214444aF5c715cc9F7b52655e788A569ed",BigInt(1000000000))


    }

    get lpx(){return this._lpx;}
    get lpxCtrlPools(){return this._lpxCtrlPools;}
    get lpxLibArbProfit(){return this._lpxLibArbProfit;}

    get wpls(){return this._wpls;}
    get erc20Helper(){return this._erc20Helper;}

    get onRefresh(){return this._onRefresh;}

    async initializeAsync(provider:ChainProvider):Promise<boolean>
    {
        try
        {
            const dataAPR = await fetch("https://lpx.plusx.app/watcher/apr");
            if (dataAPR)
            {
              const data = await dataAPR.json();
              for(const d of data) this._apr.set(d.poolId,d.apr);
            }
        } catch(e) { 
          console.error(e); }

        try
        {
            this._lpx = new LPXContract(LPXInfrastructure.ADDRESS_LPX, provider);
            this._lpxCtrlPools = new LPXCtrlPoolsContract(LPXInfrastructure.ADDRESS_LPXCtrlPools, provider);
            this._lpxLibArbProfit = new LPXLibProfitContract(LPXInfrastructure.ADDRESS_LPXLibArbProfit, provider);
            this._wpls = new WrappedETHContract(LPXInfrastructure.ADDRESS_WPLS, provider);
            this._erc20Helper = new ERC20Helper(LPXInfrastructure.ADDRESS_ERC20Helper, provider);
            App.chain.addContracts([this._lpx, this._lpxCtrlPools, this._wpls, this._erc20Helper]);
            return true;
        } catch(e) { App.gui.dialogOkShowAsync(e); }
        return false;
    }    

    async refreshAsync()
    {
        await this._onRefreshToken.invoke();
    }

    public getApr(poolId:number)
    {
        const result = this._apr.get(poolId);
        if (!result) return "-";
        return parseInt((result * 1000)+"")/10+"%";
    }

    public async getSymbolsAsync(tokens:string[]):Promise<Map<string,string>>
    {
        const result = new Map<string,string>();

        const tokenToRefresh=[]
        for(const token of tokens)
        {
            if (this._symbols.has(token)) result.set(token,this._symbols.get(token));
            else tokenToRefresh.push(token);
        }
        if (tokenToRefresh.length>0)
        {
            const symbols = await this.erc20Helper.getSymbols(tokenToRefresh);
            for(let i=0;i<tokenToRefresh.length;i++)
            {
                result.set(tokenToRefresh[i], symbols[i]);
                this._symbols.set(tokenToRefresh[i], symbols[i]);
            }
        }
        return result;
    }

    public async getSymbolAsync(token:string):Promise<string>
    {
        if (this._symbols.has(token)) return this._symbols.get(token);
      
        const symbols = await this.erc20Helper.getSymbols([token]);
        this._symbols.set(token, symbols[0]);
        return symbols[0];
    }

    public getDecimal(token:string):bigint
    {
        if (this._decimals.has(token)) return this._decimals.get(token);
        return BiMath.Decimal;
    }

    public getDecimalCorIndex(token:string): bigint {
        if (!this._decimals.has(token)) return BiMath.Decimal;
        return BiMath.Decimal/this._decimals.get(token)*BiMath.Decimal;
    }
    public getDecimalCorPairIndex(tokenF:string,tokenA:string): bigint {
        let dF = this.getDecimal(tokenF);
        let dA = this.getDecimal(tokenA);
        if (dF==dA) return BiMath.Decimal;
        if (dF<dA) return (dF*BiMath.Decimal)/dA;
        if (dF>dA) return (dF/dA)*BiMath.Decimal;
    }

    // public getAllTokens(configs:string[]):string[]
    // {
    //     const result=new Set<string>();
    //     for(const cnf of configs)
    //     {
    //         result.add(cnf.fundToken);
    //         result.add(cnf.anchorToken);
    //     }
    //     return [...result];
    // }

    public pAdrToAdr(poolAdr: bigint): string {
        // Проверка, что старшие 96 бит равны 0
        const upper = poolAdr >> BigInt(160);
        if (upper !== BigInt(0)) {
            throw new Error("LPX: no ERC20 adr");
        }
        BiMath.Decimal
        // Получаем младшие 160 бит
        const lower160 = poolAdr & ((BigInt(1) <<BigInt(160)) - BigInt(1));

        // Преобразуем в строку hex с ведущими нулями
        const hex = lower160.toString(16).padStart(40, "0");

        // Возвращаем checksummed адрес
        return ethers.getAddress("0x" + hex);
    }






    /**
     * Извлекает 17-битное значение по индексу из uint256
     */
    public getUint17FromUint256(value: bigint, index: number): bigint {
        if (index < 0 || index > 14) throw new Error("Out of range index for 17-bit extract");
        const shift = BigInt(index) * BigInt(17);
        return (value >> shift) & BigInt(0x1FFFF);
    }

    /**
     * Распаковывает структуру ConfigPack из упакованного uint256
     */
    public unpackConfigPack(pack: bigint): ConfigPack {
        return {
            feeIndex: this.getUint17FromUint256(pack, 0),
            ntzIndex: this.getUint17FromUint256(pack, 1),
            profitIndex: this.getUint17FromUint256(pack, 2),
            managerRewardIndex: this.getUint17FromUint256(pack, 3),
            poolType: Number(pack >> (BigInt(17) * BigInt(4)) & BigInt(0x0F)),
            hasPoolFlag_ManagerOnly: this.hasFlag(pack, LPXInfrastructure.PACKFLAG_MANAGER_ONLY)
        };
    }


    public calcCurrentRatio(reserve: LPXReserves): bigint {
        const numerator = reserve.anchorReserve + reserve.anchorImgReserve;
        const denominator = reserve.fundReserve + reserve.fundImgReserve;

        if (denominator === BiMath.Zero) throw new Error("Division by zero");

        return (numerator * BiMath.Decimal) / denominator;
    }




    // function _calcStartRatio(Reserve memory reserve_, uint32 fee_) internal pure returns (uint256 ratio_) {
    //     require(reserve_.anchorImgReserve > 0,  "LPX:anchorImg=0");
    //     uint256 _totalY          = reserve_.fundReserve + reserve_.fundImgReserve;
    //     uint256 _deltaY          = (reserve_.anchorReserve * _totalY) / reserve_.anchorImgReserve;
    //     uint256 _fundReserveEnd  = reserve_.fundReserve + ((_deltaY*(DECIMAL17B-fee_))/DECIMAL17B);
    //     ratio_ = ((_fundReserveEnd + reserve_.fundImgReserve) * DECIMAL) / reserve_.anchorImgReserve;
    // }


  /**
   * Вычисляет конечное соотношение резервов (start ratio) с учётом комиссии
   */
    public calcStartRatio(reserve: LPXReserves, fee17B: bigint): bigint {
        if (reserve.anchorImgReserve === BiMath.Zero)
            throw new Error("LPX: anchorImgReserve=0");

        const totalY = reserve.fundReserve + reserve.fundImgReserve;
        const deltaY = (reserve.anchorReserve * totalY) / reserve.anchorImgReserve;

        const fundReserveEnd = reserve.fundReserve + ((deltaY * (BiMath.Decimal17B - fee17B)) / BiMath.Decimal17B);

        const numerator = fundReserveEnd + reserve.fundImgReserve;
        const denominator = reserve.anchorImgReserve;

        return (denominator * BiMath.Decimal)/numerator ;
    }



  /**
   * Вычисляет конечное соотношение резервов (end ratio) с учётом комиссии
   */
    public calcEndRatio(reserve: LPXReserves, fee17B: bigint): bigint {
        if (reserve.fundImgReserve === BiMath.Zero) {
            throw new Error("LPX: fundImgReserve=0");
        }

        const totalY = reserve.anchorReserve + reserve.anchorImgReserve;
        const deltaY = (reserve.fundReserve * totalY) / reserve.fundImgReserve;

        const anchorReserveEnd = reserve.anchorReserve + ((deltaY * (BiMath.Decimal17B - fee17B)) / BiMath.Decimal17B);

        const numerator = anchorReserveEnd + reserve.anchorImgReserve;
        const denominator = reserve.fundImgReserve;

        return (numerator * BiMath.Decimal) / denominator;
    }

    public hasFlag(flag: bigint, pos: number): boolean {
        return (flag & (1n << BigInt(pos))) !== 0n;
    }



    public check(fundReserve:bigint, anchorReserve:bigint, price:bigint, endPrice:bigint, fee:bigint)
    {
    //   const fundReserve = 100000000000000000000000n; 
    //   const anchorReserve = 0n;
    // //  const anchorImgReserve = 184421000000000000n;
    //   const price = eth("0.00000341483");
    //   const endPrice = eth("0.00006146694");
    //   const anchorImgReserve = fundReserve*price/eth("1");
                                    //  0,00184421
        const reserves = new LPXReserves();
        let endPriceCheck = endPrice;
        try
        {
            const res = this._solveReserves( fundReserve, anchorReserve, price, endPrice, fee);// 561n + 890n);

            reserves.fundReserve = fundReserve;
            reserves.anchorReserve = anchorReserve;
            reserves.fundImgReserve = res.fundImgReserve;
            reserves.anchorImgReserve = res.anchorImgReserve;
            endPriceCheck = this._simulateEndPrice(reserves, fee);
            
            if (endPriceCheck>endPrice)
            {
                let t = endPriceCheck;
                endPriceCheck=endPrice;
                endPrice = t;
            }
            const delta = endPriceCheck*100n/endPrice;
            if (delta<98n) throw new Error(
                "Max Sell Price deviation is more than 2%.\n"+
                "Your Max Sell Price has been automatically adjusted.\n"+
                "Please review the new value or update other parameters if needed.\n"
            );
            return {reserves:reserves, error:"", endPrice:endPriceCheck};
        } catch (error)
        {
            let message = error.message+"";
            if (!message) message="unknown";
            return {reserves:reserves, error:message, endPrice:endPriceCheck};
        }
    }


    private _solveReserves(
    fundReserve:bigint,
    anchorReserve:bigint,
    currentRatio:bigint,
    endRatio:bigint,
    fee,
    maxIter = 10000,
    epsilon = 10n ** 8n // точность 1e-6
    ) {
        const DECIMAL = 10n ** 18n;
        const DECIMAL17B = 100000n;

        if (currentRatio>endRatio) throw new Error("Sell Price>Max Sell Price. Max Sell Price should be above Sell Price.");

        // Начальное приближение — берём fundReserve
        //c=a/f  a=c*f
        let fundImgReserve = fundReserve;
        let anchorImgReserve = ((fundImgReserve+fundReserve)*currentRatio)/DECIMAL - anchorReserve;

        let step = fundImgReserve;
        let dirUp = true;
        for (let i = 0; i < maxIter; i++) {

            const totalY = anchorReserve + anchorImgReserve;
            const deltaY = (fundReserve * totalY) / fundImgReserve;
            const anchorReserveEnd = anchorReserve + (deltaY * (DECIMAL17B - fee)) / DECIMAL17B;
            const ratio = ((anchorReserveEnd + anchorImgReserve) * DECIMAL) / fundImgReserve;

            const diff = ratio > endRatio ? ratio - endRatio : endRatio - ratio;
            if (diff <= epsilon||step==0n) {


                if (anchorImgReserve < 0n)
                {
                   anchorImgReserve = 0n;
                   fundImgReserve = anchorReserve * DECIMAL / currentRatio - fundReserve;
                }
                if (fundImgReserve<0||anchorImgReserve<0) throw new Error("Not converged");

                return {
                    fundImgReserve,
                    anchorImgReserve,
                    iterations: i,
                    actualEndRatio: ratio
                };
            }

            if (step>=fundImgReserve/6n)step=step/3n;
            if (dirUp) fundImgReserve += step; else fundImgReserve -= step;
            anchorImgReserve = currentRatio*(fundImgReserve+fundReserve)/DECIMAL - anchorReserve;
            if (ratio<endRatio&&dirUp) {dirUp=false;step=step/3n;}
            if (ratio>endRatio&&!dirUp) {dirUp=true;step=step/3n;}
        }
        throw new Error("Not converged");
    }

    private _simulateEndPrice(reserves:LPXReserves, feeRatio:bigint) {
        const DECIMAL = 10n ** 18n;
        const DECIMAL17B = 100000n;
        let fundReserve = reserves.fundReserve;
        let fundImgReserve = reserves.fundImgReserve;
        let anchorReserve = reserves.anchorReserve;
        let anchorImgReserve = reserves.anchorImgReserve;


        if (fundImgReserve === 0n) throw new Error("fundImgReserve must be > 0");
        if (feeRatio < 0n || feeRatio > DECIMAL17B) throw new Error("feeRatio out of range");

        // начальный real-фонд для расчёта шага
        const initialFund = fundReserve;

        // шаг = 0.001% от initialFund = initialFund / 100_000
        let step = initialFund / 100_000n;
        if (step < 1n) step = 1n; // минимум 1 единица

        while (fundReserve > 0n) {
            // если до конца осталось меньше шага, продаём остаток
            const dx = fundReserve < step ? fundReserve : step;

            // общая anchor-ликвидность
            const totalY = anchorReserve + anchorImgReserve;

            // Δy = dx * totalY / (fundReserve + fundImgReserve)
            const dy = (dx * totalY) / (fundReserve + fundImgReserve);

            // net incoming anchor после fee
            const netDy = (dy * (DECIMAL17B - feeRatio)) / DECIMAL17B;

            // обновляем резервы
            anchorReserve += netDy;
            fundReserve  -= dx;
        }

        // после fundReserve → 0, конечная цена:
        // (anchorReserve + anchorImgReserve) / fundImgReserve
        const endPrice = ((anchorReserve + anchorImgReserve) * DECIMAL) / fundImgReserve;

        return endPrice;
    }

}